export var TargetSegmentEnum = /*#__PURE__*/function (TargetSegmentEnum) {
  TargetSegmentEnum["Admin"] = "admin";
  TargetSegmentEnum["EndUser"] = "end-user";
  TargetSegmentEnum["Leader"] = "leader";
  return TargetSegmentEnum;
}({});